import { ENV } from '.';

const PROD_BASE_DOMAIN = 'sfshop-api.sfcinemacity.com';
const UAT_BASE_DOMAIN = 'sfshop-apiuat.sfcinemacity.com';
const DEV_BASE_DOMAIN = 'sfshop-apidev.sfcinemacity.com';
const SIT_BASE_DOMAIN = 'sfshopsit-api.sfcinemacity.com';
const LOCAL_BASE_DOMAIN = 'localhost:44324';


export const BASE_DOMAIN = ENV === 'production' 
    ? PROD_BASE_DOMAIN 
    : (ENV === 'staging' 
        ? UAT_BASE_DOMAIN 
        : (ENV == 'local'
            ? LOCAL_BASE_DOMAIN
            : (ENV == 'sit'
                ? SIT_BASE_DOMAIN
                : DEV_BASE_DOMAIN)
            )
        );

export const BASE_RESOURCE_DOMAIN = ENV === 'production' 
    ? PROD_BASE_DOMAIN 
    : (ENV === 'staging' 
        ? UAT_BASE_DOMAIN 
        : (ENV == 'local'
            ? PROD_BASE_DOMAIN
            : (ENV == 'sit'
                ? SIT_BASE_DOMAIN
                : DEV_BASE_DOMAIN)
            )
        );

export const BASE_URL = `https://${BASE_DOMAIN}`
export const BASE_RESOURCE_URL = `https://${BASE_RESOURCE_DOMAIN}`